import useFormContext from "../../../hooks/useFormContext"
import React from "react";
import {translate} from "../../../i18n";
import {useDispatch, useSelector} from "react-redux";
import {setFormField} from "../../../store/reducers/registrationSlice";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import countryList from "react-select-country-list"; // optional for predefined countries

const Documents = ({fields, files = [],  handleFileChange, handleRemoveFile, fileInputRef}) => {

    const { data, handleChange, errors, importExportFiles,
        handleRemoveImportExportFile, handleRemovePowerOfAttorneyFile, powerOfAttorneyFiles, handleImportExportChange, handlePowerOfAttorneyChange} = useFormContext()
    const dispatch = useDispatch();
    const language_code = useSelector(state => state.lang);
    const iso2 = useSelector((s) => s.country.country?.value) || 'TG';
    const compantCountryCode = iso2.toLowerCase();

    // Country options (could come from API or static list)
    const options = countryList().getData(); // [{value: 'TG', label: 'Togo'}, ...]

    // Convert data.countriesOfOperation (comma string) to array for react-select
    const selectedCountries = data.countriesOfOperation
        ? data.countriesOfOperation.split(",").map(code => {
            const found = options.find(opt => opt.value === code.trim());
            return found || { value: code.trim(), label: code.trim() };
        })
        : [];

    const content = (
        <>

                <div className="flex-col">
                    <label htmlFor="countriesOfOperation">
                        {translate("signup", language_code.lang).countriesOfOperation}
                    </label>
                    <Select
                        id="countriesOfOperation"
                        name="countriesOfOperation"
                        placeholder={translate("signup", language_code.lang).select_placeholder}
                        isMulti
                        options={options}
                        value={selectedCountries}
                        onChange={(selected) => {
                            const commaSeparated = selected.map(opt => opt.value).join(",");
                            handleChange({
                                target: {
                                    name: "countriesOfOperation",
                                    value: commaSeparated
                                }
                            });
                        }}
                    />
                    {errors.countriesOfOperation && (
                        <span style={{ color: "red" }}>{errors.countriesOfOperation}</span>
                    )}
                </div>

                <div className="flex-col">
                    <label htmlFor="companyPhoneNumber">{translate('signup', language_code.lang).companyPhoneNumber}</label>
                    <PhoneInput
                        country={compantCountryCode}
                        value={data.companyPhoneNumber}
                        onChange={(phone) => handleChange("companyPhoneNumber", phone)}
                        inputProps={{
                            name: 'companyPhoneNumber',
                            required: true
                        }}
                    />
                    {errors.companyPhoneNumber && <span style={{ color: "red" }}>{errors.companyPhoneNumber}</span>}
                </div>

                <div className="flex-col">
                    <label htmlFor="companyEmail">{translate('signup', language_code.lang).companyEmail}</label>
                    <input
                        type="text"
                        id="companyEmail"
                        name="companyEmail"
                        placeholder="companyEmail"
                        value={data.companyEmail}
                        onChange={handleChange}
                    />
                    {errors.companyEmail&& <span style={{ color: "red" }}>{errors.companyEmail}</span>}
                </div>

                <div className="flex-col">
                    <label htmlFor="subscriptionPlan">{translate('signup', language_code.lang).subscriptionPlan}</label>
                    <select
                        id="subscriptionPlan"
                        name="subscriptionPlan"
                        placeholder="choisir"
                        value={data.subscriptionPlan}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="basic">{translate('company_informations', language_code.lang).subscription_plans.basic}</option>
                        <option value="silver">{translate('company_informations', language_code.lang).subscription_plans.silver}</option>
                        <option value="premium">{translate('company_informations', language_code.lang).subscription_plans.premium}</option>
                        <option value="gold">{translate('company_informations', language_code.lang).subscription_plans.gold}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="optInEco">{translate('signup', language_code.lang).optInEco}</label>
                    <select
                        id="optInEco"
                        name="optInEco"
                        placeholder="choisir"
                        value={data.optInEco}
                        onChange={handleChange}
                    >
                        <option value="">{translate('signup', language_code.lang).select_placeholder}</option>
                        <option value="true">{translate('signup', language_code.lang).yes}</option>
                        <option value="false">{translate('signup', language_code.lang).no}</option>
                    </select>
                </div>

                <div className="flex-col">
                    <label htmlFor="wishesWhenRegistering">
                        {translate('signup', language_code.lang).wishesWhenRegistering}
                    </label>
                    <textarea
                        id="wishesWhenRegistering"
                        name="wishesWhenRegistering"
                        rows={4}
                        value={data.wishesWhenRegistering || ""}
                        onChange={handleChange}
                        placeholder={translate('signup', language_code.lang).wishes_placeholder}
                    />
                    {errors.wishesWhenRegistering && (
                        <span style={{ color: "red" }}>{errors.wishesWhenRegistering}</span>
                    )}
                </div>

                <div className="flex-col">
                    <label htmlFor="importExportFiles">{translate('signup', language_code.lang).importExportProof}</label>
                    <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        id="importExportFiles"
                        multiple
                        onChange={handleImportExportChange}
                    />

                    {importExportFiles.length === 0 && (
                        <p className="text-danger">
                            {translate('company_informations', language_code.lang).company_documents.import_export_proof}
                        </p>
                    )}

                    {importExportFiles.length > 0 && (
                        <ul className="mt-2">
                            {importExportFiles.map((file, index) => (
                                <li key={index} className="d-flex flex-column gap-1 mb-2">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span>{file.name}</span>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-danger"
                                            onClick={() => handleRemoveImportExportFile(file.name)}
                                        >
                                            {translate('button', language_code.lang).delete_button}
                                        </button>
                                    </div>
                                    {file.type.startsWith("image/") && (
                                        <img
                                            src={URL.createObjectURL(file)}
                                            alt={file.name}
                                            style={{
                                                width: '120px',
                                                height: 'auto',
                                                objectFit: 'cover',
                                                borderRadius: '6px',
                                            }}
                                        />
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <div className="flex-col">
                        <label htmlFor="powerOfAttorneyFile">{translate('signup', language_code.lang).powerOfAttorneyFile}</label>
                        <input
                            type="file"
                            accept=".pdf,.jpg,.jpeg,.png"
                            id="powerOfAttorneyFile"
                            multiple
                            onChange={handlePowerOfAttorneyChange}
                        />

                        {powerOfAttorneyFiles.length === 0 && (
                            <p className="text-danger">
                                {translate('company_informations', language_code.lang).company_documents.power_of_attorney}
                            </p>
                        )}

                        {powerOfAttorneyFiles.length > 0 && (
                            <ul className="mt-2">
                                {powerOfAttorneyFiles.map((file, index) => (
                                    <li key={index} className="d-flex flex-column gap-1 mb-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>{file.name}</span>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger"
                                                onClick={() => handleRemovePowerOfAttorneyFile(file.name)}
                                            >
                                                {translate('button', language_code.lang).delete_button}
                                            </button>
                                        </div>
                                        {file.type.startsWith("image/") && (
                                            <img
                                                src={URL.createObjectURL(file)}
                                                alt={file.name}
                                                style={{
                                                    width: '120px',
                                                    height: 'auto',
                                                    objectFit: 'cover',
                                                    borderRadius: '6px',
                                                }}
                                            />
                                        )}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

        </>
    )

    return content
}
export default Documents